import { render } from "./LabsByFloor.vue?vue&type=template&id=46948f38"
import script from "./LabsByFloor.vue?vue&type=script&lang=js"
export * from "./LabsByFloor.vue?vue&type=script&lang=js"
script.render = render

export default script